import { lazy } from 'react';

import { PageSuspense } from 'src/components';


const AccountClientContactUpdatePage = lazy(() => import('../views/update/AccountClientContactUpdatePage'));

export function AccountClientContactUpdatePageLazy() {
	return (
		<PageSuspense>
			<AccountClientContactUpdatePage />
		</PageSuspense>
	);
}
